import React from 'react';
import { Headline, Subtext } from '../../components/ScreenShell';
import { TextAreaField } from '../../components/ui/Field';
import { PrimaryButton } from '../../components/ui/PrimaryButton';
import { useCopy } from '../../contexts/LanguageContext';
import type { StepProps } from '../../types/quiz';
export function StepPersonalTouch({
  profile,
  update,
  onNext
}: StepProps) {
  const copy = useCopy();
  return <div className="flex flex-1 flex-col" data-id="element-148" data-mp="8a01akzehgfw">
      <Headline data-id="element-149" data-mp="86vr96z97qhb">{copy.steps.personal.headline}</Headline>
      <Subtext data-id="element-150" data-mp="d938aayxxwqi">{copy.steps.personal.question(profile.child_name)}</Subtext>

      <div className="mt-6 space-y-7" data-id="element-151" data-mp="i6mkz6fzq1gc">
        <TextAreaField id="special-detail" value={profile.special_detail} onChange={value => update({
        special_detail: value
      })} rows={5} placeholder={copy.steps.personal.detailPlaceholder} data-id="element-152" data-mp="i5jvn2ybg72j" />

        <TextAreaField id="parent-message" label={copy.steps.personal.messageLabel} value={profile.parent_message} onChange={value => update({
        parent_message: value
      })} rows={4} placeholder={copy.steps.personal.messagePlaceholder} data-id="element-153" data-mp="3qmoh3kxtwwca" />
      </div>

      <div className="mt-auto pt-10" data-id="element-154" data-mp="2p0zsf0k50ypo">
        <PrimaryButton onClick={onNext} disabled={profile.special_detail.trim().length === 0} data-id="element-155" data-mp="2ozygktvas86w">
          {copy.quiz.seeSummary}
        </PrimaryButton>
      </div>
    </div>;
}